import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconStatusIndicator(props: IconProps) {
  return (
    <BaseIcon dataTestid={props.dataTestid || 'status-indicator'} {...props}>
      <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" fill="currentColor" />
    </BaseIcon>
  );
}
